const that = window.eventBus

export const searchConfig = function (supplierList) {
  let searchConfigs = [
    {
      key: ['filterObj', 'value'],
      searchType: 'selectInput',
      componentData: {
        defaultValue: ['1', ''],
        options: [
          { label: that.$t('storage::commodity-stocks::platform_sku'), value: '1' },
          { label: that.$t('storage::commodity-stocks:platform_spu'), value: '2' },
          { label: that.$t('storage::commodity-stocks:shop_name'), value: '3' },
        ],
      },
    },
    {
      label: that.$t('storage::commodity-stocks:supplier'),
      key: 'supplier_id',
      searchType: 'select',
      componentData: {
        dictKey: 'supplier_id',
        clearable: true,
        options: supplierList,
      },
    },
    {
      label: that.$t('storage::commodity-stocks:no_stock'),
      key: 'enough_stock',
      searchType: 'select',
      componentData: {
        dictKey: 'enough_stock',
        clearable: true,
        options: [
          { label: that.$t('storage::commodity-stocks:true'), value: 1 },
          { label: that.$t('storage::commodity-stocks:false'), value: 0 },
        ],
      },
    }
  ]
  return searchConfigs;
}
export const STOCKS_COLUMNS = [
  {
    type: 'selection',
    fixed: 'left'
  },
  {
    label: that.$t('stores::products-info::goods_info'),
    prop: 'SKU',
    minWidth: 200,
    showOverflowTooltip: true,
    fixed: 'left'
  },
  // {
  //   label: that.$t('storage::commodity-stocks::platform_table_spu'),
  //   prop: 'spu',
  //   minWidth: 120
  // },
  // {
  //   label: that.$t('storage::commodity-stocks::platform_table_commodity'),
  //   prop: 'productName',
  //   minWidth: 120
  // },
  // {
  //   label: that.$t('storage::commodity-stocks::platform_table_pic'),
  //   prop: 'imageUrl',
  //   minWidth: 120
  // },
  {
    label: that.$t('storage::commodity-stocks::platform_table_supplier'),
    prop: 'supplier',
    minWidth: 120
  },
  {
    label: that.$t('storage::commodity-stocks::platform_table_pat_cost'),
    slotHeaderName: 'supplyCostHeader',
    prop: 'supplyCost',
    minWidth: 150
  },
  {
    label: that.$t('storage::commodity-stocks::platform_table_stock'),
    prop: 'stock',
    minWidth: 120
  },
  {
    label: that.$t('storage::commodity-stocks::platform_table_stock_amount'),
    slotHeaderName: 'valuationStockHeader',
    prop: 'valuationStock',
    minWidth: 140
  },
]

export const STOCKS_FLOW_COLUMNS = [
  {
    label: that.$t('storage::commodity-stocks::stock_flow_bill_code'),
    prop: 'orderNo',
    minWidth: 120
  },
  {
    label: that.$t('storage::commodity-stocks::stock_flow_before_stock'),
    prop: 'beforeChangeStock',
    minWidth: 120
  },
  {
    label: that.$t('storage::commodity-stocks::stock_flow_change'),
    prop: 'changeValue',
    minWidth: 120
  },
  {
    label: that.$t('storage::commodity-stocks::stock_flow_after_stock'),
    prop: 'afterChangeStock',
    minWidth: 120
  },
  {
    label: that.$t('storage::commodity-stocks::stock_flow_change_time'),
    prop: 'changeTime',
    minWidth: 120
  },
]

export const ORDER_STATUS = {
  1: { label: that.$t('storage::commodity-stocks::stock_flow_wait_audit'), color: '#0000ff' },
  2: { label: that.$t('storage::commodity-stocks::stock_flow_audited'), color: '#00c086' },
  3: { label: that.$t('storage::commodity-stocks::stock_flow_closed'), color: '#d9001b' }
}
